/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import receiveLocations from './receive-locations';
import * as actions from 'state/action-types';

export default (locationId = null) => (dispatch) => {
    return cecSdk
        .location(locationId)
        .remove()
        .then(() => {
            dispatch({ type: actions.DELETE_LOCATION_SUCCESS, payload: { locationId } });
        });
};
